<template>
  <div class="calendar-container">
    <el-card class="filter-container" shadow="never">
      <div class="filter-title">
        <span>{{ roomName ? roomName : '房间日历' }}</span>
        <el-button
          v-if="roomId"
          style="float: right; margin-left: 10px;"
          @click="goBack"
          size="small">
          返回列表
        </el-button>
        <el-button
          style="float: right"
          @click="showAddEventDialog()"
          type="primary"
          size="small">
          添加临时预约
        </el-button>
      </div>
      <div class="form-container">
        <el-form :inline="true" :model="searchForm" size="small" label-width="100px">
          <el-form-item label="房间" v-if="!roomId">
            <el-select v-model="searchForm.roomId" placeholder="请选择房间" filterable clearable @change="handleRoomChange">
              <el-option
                v-for="item in roomOptions"
                :key="item.id"
                :label="item.roomName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视图类型">
            <el-select v-model="calendarOptions.initialView" placeholder="请选择视图类型">
              <el-option label="月视图" value="dayGridMonth"></el-option>
              <el-option label="周视图" value="timeGridWeek"></el-option>
              <el-option label="日视图" value="timeGridDay"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    
    <el-card class="calendar-card">
      <FullCalendar 
        ref="fullCalendar" 
        :options="calendarOptions" 
        class="full-calendar"
      />
    </el-card>

    <!-- 添加临时预约对话框 -->
    <el-dialog title="添加临时预约" :visible.sync="eventDialogVisible" width="40%">
      <el-form :model="eventForm" :rules="eventRules" ref="eventForm" label-width="100px">
        <el-form-item label="房间" prop="roomId" v-if="!roomId">
          <el-select v-model="eventForm.roomId" placeholder="请选择房间" filterable>
            <el-option
              v-for="item in roomOptions"
              :key="item.id"
              :label="item.roomName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="eventForm.title" placeholder="请输入预约标题"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
            v-model="eventForm.startTime"
            type="datetime"
            placeholder="选择开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            v-model="eventForm.endTime"
            type="datetime"
            placeholder="选择结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="eventForm.type" placeholder="请选择预约类型">
            <el-option label="团体课" value="团体课"></el-option>
            <el-option label="私教课" value="私教课"></el-option>
            <el-option label="临时预约" value="临时预约"></el-option>
            <el-option label="场地维护" value="场地维护"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            type="textarea"
            v-model="eventForm.description"
            placeholder="请输入预约描述"
            :rows="3"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="eventDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEventForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看/编辑预约对话框 -->
    <el-dialog :title="isViewingEvent ? '查看预约' : '编辑预约'" :visible.sync="viewEventDialogVisible" width="40%">
      <el-form :model="viewEventForm" :rules="eventRules" ref="viewEventForm" label-width="100px" :disabled="isViewingEvent">
        <el-form-item label="房间" prop="roomId" v-if="!roomId">
          <el-select v-model="viewEventForm.roomId" placeholder="请选择房间" filterable disabled>
            <el-option
              v-for="item in roomOptions"
              :key="item.id"
              :label="item.roomName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="viewEventForm.title" placeholder="请输入预约标题"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
            v-model="viewEventForm.startTime"
            type="datetime"
            placeholder="选择开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            v-model="viewEventForm.endTime"
            type="datetime"
            placeholder="选择结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-input v-model="viewEventForm.type" disabled></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            type="textarea"
            v-model="viewEventForm.description"
            placeholder="请输入预约描述"
            :rows="3"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewEventDialogVisible = false">关 闭</el-button>
        <el-button v-if="!isViewingEvent" type="primary" @click="updateEvent">保 存</el-button>
        <el-button v-if="!isViewingEvent && canDelete" type="danger" @click="deleteEvent">删 除</el-button>
        <el-button v-if="isViewingEvent && canEdit" type="warning" @click="editEvent">编 辑</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatDate } from '@/utils/date'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import zhCnLocale from '@fullcalendar/core/locales/zh-cn'

export default {
  components: {
    FullCalendar
  },
  data() {
    return {
      roomId: null,
      roomName: '',
      roomOptions: [],
      searchForm: {
        roomId: null
      },
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: 'timeGridWeek',
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay'
        },
        locale: zhCnLocale,
        firstDay: 1, // 周一开始
        allDaySlot: false,
        slotMinTime: '06:00:00',
        slotMaxTime: '23:00:00',
        slotDuration: '00:30:00',
        height: 'auto',
        expandRows: true,
        events: [],
        eventClick: this.handleEventClick,
        dateClick: this.handleDateClick,
        editable: false, // 是否可拖动
        selectable: true, // 是否可选择
        select: this.handleSelectDateRange
      },
      eventDialogVisible: false,
      viewEventDialogVisible: false,
      isViewingEvent: true,
      canEdit: false,
      canDelete: false,
      currentEventId: null,
      eventForm: {
        roomId: null,
        title: '',
        startTime: '',
        endTime: '',
        type: '临时预约',
        description: ''
      },
      viewEventForm: {
        id: null,
        roomId: null,
        title: '',
        startTime: '',
        endTime: '',
        type: '',
        description: ''
      },
      eventRules: {
        roomId: [
          { required: true, message: '请选择房间', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入预约标题', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择预约类型', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    if (this.$route.query.roomId) {
      this.roomId = parseInt(this.$route.query.roomId)
      this.roomName = this.$route.query.roomName || ''
      this.searchForm.roomId = this.roomId
      this.eventForm.roomId = this.roomId
    }
    
    this.loadRooms()
  },
  mounted() {
    console.log("组件已挂载");
    this.loadEvents()
    
    // 检查URL参数是否需要自动打开添加预约对话框
    if (this.$route.query.openAddDialog === 'true') {
      // 延迟执行，确保数据已加载
      setTimeout(() => {
        this.showAddEventDialog();
      }, 500);
    }
  },
  methods: {
    loadRooms() {
      this.$http({
        url: '/room/page',
        method: 'get',
        params: {
          status: '可用' // 只加载可用的房间
        }
      }).then(({ data }) => {
        console.log("获取房间列表成功:", data);
        if (data && data.code === 0) {
          this.roomOptions = data.data || []
        } else {
          console.warn("获取房间列表返回异常:", data);
          this.roomOptions = [];
        }
      }).catch(error => {
        console.error("获取房间列表失败:", error);
        this.roomOptions = [];
        
        // 临时解决方案：如果API未实现，添加一些测试数据
        if (process.env.NODE_ENV !== 'production') {
          this.roomOptions = [
            { id: 1, roomName: '瑜伽教室A' },
            { id: 2, roomName: '私教房间B' },
            { id: 3, roomName: '舞蹈室C' },
            { id: 4, roomName: '器械区D' }
          ];
        }
      })
    },
    loadEvents() {
      // 计算当前视图的开始和结束日期
      let startDate, endDate;
      
      // 检查fullCalendar引用是否存在
      if (this.$refs.fullCalendar) {
        try {
          let calendarApi = this.$refs.fullCalendar.getApi();
          startDate = formatDate(calendarApi.view.activeStart, 'YYYY-MM-DD');
          endDate = formatDate(calendarApi.view.activeEnd, 'YYYY-MM-DD');
        } catch (error) {
          console.error("获取日历API失败:", error);
        }
      }
      
      // 如果无法从日历API获取日期，使用当前月份作为默认值
      if (!startDate || !endDate) {
        let now = new Date();
        startDate = formatDate(new Date(now.getFullYear(), now.getMonth(), 1), 'YYYY-MM-DD');
        endDate = formatDate(new Date(now.getFullYear(), now.getMonth() + 1, 0), 'YYYY-MM-DD');
      }
      
      console.log("加载日历事件，日期范围:", startDate, "至", endDate, "房间ID:", this.searchForm.roomId);
      
      this.$http({
        url: '/room/calendar/events',
        method: 'get',
        params: {
          startDate: startDate,
          endDate: endDate,
          roomId: this.searchForm.roomId
        }
      }).then(({ data }) => {
        console.log("获取预约事件成功:", data);
        if (data && data.code === 0) {
          const formattedEvents = this.formatEvents(data.data || []);
          console.log("格式化后的事件:", formattedEvents);
          
          // 直接更新日历API的事件源
          if (this.$refs.fullCalendar) {
            const calendarApi = this.$refs.fullCalendar.getApi();
            calendarApi.removeAllEvents();
            formattedEvents.forEach(event => {
              calendarApi.addEvent(event);
            });
          } else {
            this.calendarOptions.events = formattedEvents;
          }
        } else {
          console.warn("获取预约事件返回异常:", data);
          this.calendarOptions.events = [];
          
          if (this.$refs.fullCalendar) {
            const calendarApi = this.$refs.fullCalendar.getApi();
            calendarApi.removeAllEvents();
          }
        }
      }).catch(error => {
        console.error("获取预约事件失败:", error);
        if (this.$refs.fullCalendar) {
          const calendarApi = this.$refs.fullCalendar.getApi();
          calendarApi.removeAllEvents();
        } else {
          this.calendarOptions.events = [];
        }
        
        // 临时解决方案：如果API未实现，添加一些测试数据
        if (process.env.NODE_ENV !== 'production') {
          const now = new Date();
          const tomorrow = new Date();
          tomorrow.setDate(now.getDate() + 1);
          
          // 生成测试数据
          const testEvents = [
            {
              id: 1,
              title: '团体瑜伽课',
              type: '团体课',
              roomId: 1,
              roomName: '瑜伽教室A',
              startTime: formatDate(new Date(new Date().setHours(10, 0, 0)), 'YYYY-MM-DD HH:mm:ss'),
              endTime: formatDate(new Date(new Date().setHours(11, 30, 0)), 'YYYY-MM-DD HH:mm:ss'),
              description: '初级瑜伽课程',
              sourceType: 'appointment'
            },
            {
              id: 2,
              title: '私教训练',
              type: '私教课',
              roomId: 2,
              roomName: '私教房间B',
              startTime: formatDate(new Date(tomorrow.setHours(14, 0, 0)), 'YYYY-MM-DD HH:mm:ss'),
              endTime: formatDate(new Date(tomorrow.setHours(15, 0, 0)), 'YYYY-MM-DD HH:mm:ss'),
              description: '力量训练',
              sourceType: 'appointment'
            },
            {
              id: 3,
              title: '设备维护',
              type: '场地维护',
              roomId: 4,
              roomName: '器械区D',
              startTime: formatDate(new Date(tomorrow.setHours(8, 0, 0)), 'YYYY-MM-DD HH:mm:ss'),
              endTime: formatDate(new Date(tomorrow.setHours(9, 0, 0)), 'YYYY-MM-DD HH:mm:ss'),
              description: '定期设备维护',
              sourceType: 'temporary'
            }
          ];
          
          const formattedTestEvents = this.formatEvents(testEvents);
          console.log("使用测试数据:", formattedTestEvents);
          
          if (this.$refs.fullCalendar) {
            const calendarApi = this.$refs.fullCalendar.getApi();
            formattedTestEvents.forEach(event => {
              calendarApi.addEvent(event);
            });
          } else {
            this.calendarOptions.events = formattedTestEvents;
          }
        }
      })
    },
    formatEvents(events) {
      if (!events || !Array.isArray(events)) {
        console.warn("事件数据不是数组:", events);
        return [];
      }
      
      console.log("格式化前的事件数据:", events);
      
      return events.map(event => {
        let color = '#409EFF' // 默认蓝色
        
        // 获取事件类型，可能在extendedProps中或顶层
        const eventType = (event.extendedProps && event.extendedProps.occupationType) || 
                          (event.extendedProps && event.extendedProps.type) || 
                          event.type || '临时预约';
        
        // 根据类型设置颜色
        switch(eventType) {
          case '团体课':
            color = '#67C23A' // 绿色
            break
          case '私教课':
            color = '#E6A23C' // 橙色
            break
          case '临时预约':
            color = '#409EFF' // 蓝色
            break
          case '场地维护':
            color = '#F56C6C' // 红色
            break
          case '清洁':
            color = '#909399' // 灰色
            break
        }
        
        // 优先使用事件自带的颜色
        if (event.backgroundColor) {
          color = event.backgroundColor;
        }
        
        // 直接使用start和end字段，或者尝试使用startTime和endTime
        const startTime = event.start || event.startTime;
        const endTime = event.end || event.endTime;
        
        const roomId = (event.extendedProps && event.extendedProps.roomId) || event.roomId || (event.resourceId && parseInt(event.resourceId));
        
        const formattedEvent = {
          id: event.id,
          title: event.title,
          start: startTime,
          end: endTime,
          color: color,
          extendedProps: {
            description: (event.extendedProps && event.extendedProps.description) || event.description,
            type: eventType,
            roomId: roomId,
            roomName: (event.extendedProps && event.extendedProps.roomName) || event.roomName,
            createdBy: (event.extendedProps && event.extendedProps.createdBy) || event.createdBy,
            sourceType: (event.extendedProps && event.extendedProps.sourceType) || 
                        (event.extendedProps && event.extendedProps.type === 'occupation' ? 'temporary' : 'appointment'),
            sourceId: (event.extendedProps && event.extendedProps.sourceId) || event.sourceId
          }
        };
        
        console.log("格式化后的单个事件:", formattedEvent);
        return formattedEvent;
      });
    },
    handleRoomChange() {
      this.loadEvents()
    },
    handleEventClick(info) {
      this.isViewingEvent = true
      this.currentEventId = info.event.id
      
      // 根据预约来源决定是否可以编辑或删除
      this.canEdit = info.event.extendedProps.sourceType === 'temporary'
      this.canDelete = info.event.extendedProps.sourceType === 'temporary'
      
      // 使用正确的日期格式字符串
      const formatDateForPicker = (date) => {
        if (!date) return '';
        const jsDate = new Date(date);
        if (isNaN(jsDate.getTime())) {
          console.error("无效的日期对象:", date);
          return '';
        }
        const pad = (n) => (n < 10 ? `0${n}` : n);
        return `${jsDate.getFullYear()}-${pad(jsDate.getMonth() + 1)}-${pad(jsDate.getDate())} ${pad(jsDate.getHours())}:${pad(jsDate.getMinutes())}:${pad(jsDate.getSeconds())}`;
      };
      
      this.viewEventForm = {
        id: info.event.id,
        roomId: info.event.extendedProps.roomId,
        title: info.event.title,
        startTime: formatDateForPicker(info.event.start),
        endTime: formatDateForPicker(info.event.end),
        type: info.event.extendedProps.type,
        description: info.event.extendedProps.description
      }
      
      this.viewEventDialogVisible = true
    },
    handleDateClick(info) {
      // 点击日期时，弹出预约表单，设置默认开始时间
      try {
        const clickDate = new Date(info.date);
        if (isNaN(clickDate.getTime())) {
          console.error("无效的日期点击:", info.date);
          this.showAddEventDialog(); // 使用默认日期
        } else {
          this.showAddEventDialog(clickDate);
        }
      } catch (error) {
        console.error("处理日期点击事件出错:", error);
        this.showAddEventDialog(); // 使用默认日期
      }
    },
    handleSelectDateRange(info) {
      // 选择时间范围时，弹出预约表单，设置默认时间范围
      try {
        const startDate = new Date(info.start);
        const endDate = new Date(info.end);
        
        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
          console.error("无效的日期范围选择:", info.start, info.end);
          this.showAddEventDialog(); // 使用默认日期
        } else {
          this.showAddEventDialog(startDate, endDate);
        }
      } catch (error) {
        console.error("处理日期范围选择事件出错:", error);
        this.showAddEventDialog(); // 使用默认日期
      }
    },
    showAddEventDialog(startDate = null, endDate = null) {
      // 检查参数类型，如果是事件对象，则忽略它
      if (startDate && typeof startDate === 'object' && startDate.type) {
        console.log('检测到事件对象作为参数传入，将使用默认日期');
        startDate = null;
        endDate = null;
      }
      
      // 如果没有传入日期，使用当前时间
      let startDateTime = startDate ? new Date(startDate) : new Date();
      let endDateTime = null;
      
      if (endDate) {
        endDateTime = new Date(endDate);
      } else {
        // 如果没有传入结束时间，默认设置为开始时间后1小时
        endDateTime = new Date(startDateTime.getTime());
        endDateTime.setHours(endDateTime.getHours() + 1);
      }
      
      // 检查日期是否有效
      if (isNaN(startDateTime.getTime()) || isNaN(endDateTime.getTime())) {
        console.error("无效的日期对象:", startDate, endDate);
        startDateTime = new Date();
        endDateTime = new Date(startDateTime.getTime());
        endDateTime.setHours(endDateTime.getHours() + 1);
      }
      
      // 使用正确的日期格式字符串，确保与Element UI日期选择器的value-format匹配
      const formatDateForPicker = (date) => {
        const pad = (n) => (n < 10 ? `0${n}` : n);
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
      };
      
      this.eventForm = {
        roomId: this.roomId || this.searchForm.roomId || null,
        title: '',
        startTime: formatDateForPicker(startDateTime),
        endTime: formatDateForPicker(endDateTime),
        type: '临时预约',
        description: ''
      }
      
      this.eventDialogVisible = true
    },
   submitEventForm() {
  this.$refs.eventForm.validate((valid) => {
    if (valid) {
      // 验证时间是否合理
      if (new Date(this.eventForm.startTime) >= new Date(this.eventForm.endTime)) {
        this.$message.error('结束时间必须晚于开始时间')
        return
      }
      // 检查 roomId 是否存在
      if (!this.eventForm.roomId) {
        this.$message.error('请选择房间')
        return
      }
      
      // 输出 eventForm 对象的数据
      console.log("提交的表单数据:", this.eventForm);
      
      // 根据后端接口要求，所有参数作为请求参数传递，而不是请求体
      this.$http({
        url: '/room/calendar/temporary',
        method: 'post',
        params: {
          roomId: Number(this.eventForm.roomId),
          startTime: this.eventForm.startTime,
          endTime: this.eventForm.endTime,
          title: this.eventForm.title,
          description: this.eventForm.description || '',
          type: this.eventForm.type
        }
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$message({
            message: '预约创建成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.eventDialogVisible = false
              this.loadEvents()
            }
          })
        } else {
          this.$message.error(data.msg || '操作失败')
        }
      }).catch(error => {
        console.error("创建临时预约失败:", error.response ? error.response.data : error);
        this.$message.error(error.response && error.response.data ? error.response.data.msg : '服务器异常，请稍后重试');
      })
    }
  })
},
    editEvent() {
      this.isViewingEvent = false
    },
    updateEvent() {
      this.$refs.viewEventForm.validate((valid) => {
        if (valid) {
          // 验证时间是否合理
          if (new Date(this.viewEventForm.startTime) >= new Date(this.viewEventForm.endTime)) {
            this.$message.error('结束时间必须晚于开始时间')
            return
          }
          
          this.$http({
            url: '/room/calendar/update',
            method: 'post',
            data: {
              id: this.viewEventForm.id,
              startTime: this.viewEventForm.startTime,
              endTime: this.viewEventForm.endTime,
              title: this.viewEventForm.title,
              description: this.viewEventForm.description
            }
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: '预约更新成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.viewEventDialogVisible = false
                  this.loadEvents()
                }
              })
            } else {
              this.$message.error(data.msg || '操作失败')
            }
          })
        }
      })
    },
    deleteEvent() {
      this.$confirm('确认删除该预约?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/room/calendar/delete/' + this.currentEventId,
          method: 'post'
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.viewEventDialogVisible = false
                this.loadEvents()
              }
            })
          } else {
            this.$message.error(data.msg || '操作失败')
          }
        })
      }).catch(() => {})
    },
    goBack() {
      this.$router.push('/room')
    }
  }
}
</script>

<style scoped>
.calendar-container {
  padding: 20px;
}
.filter-container {
  margin-bottom: 20px;
}
.filter-title {
  font-size: 18px;
  font-weight: bold;
}
.form-container {
  margin-top: 20px;
}
.calendar-card {
  margin-bottom: 20px;
}
.full-calendar {
  min-height: 700px;
}
</style> 